import {Composition} from 'remotion';
import {Main} from './MapAnimation/Main';
import {
	CompositionProps,
	DURATION_IN_FRAMES,
	Point,
	VIDEO_FPS,
	VIDEO_HEIGHT,
	VIDEO_WIDTH,
} from './constants';

const zurich: Point = {
	latitude: 47.3738781,
	longitude: 8.5450941,
};

const la: Point = {
	latitude: 34.0522351,
	longitude: -118.2436831,
};

export const RemotionRoot: React.FC = () => {
	return (
		<>
			<Composition
				id={'MapAnimation'}
				component={Main}
				durationInFrames={DURATION_IN_FRAMES}
				fps={VIDEO_FPS}
				width={VIDEO_WIDTH}
				height={VIDEO_HEIGHT}
				defaultProps={{
					endLabel: 'Zurich',
					endPoint: zurich,
					startLabel: 'Los Angeles',
					startPoint: la,
				}}
				schema={CompositionProps}
			/>
		</>
	);
};
